import React, { useState } from 'react';
import { StyleSheet, View, Linking, Image, SafeAreaView, ScrollView } from 'react-native';
import { useSelector } from 'react-redux';
import NavigateRow from '../NavigateRow';
import BaseText from '../BaseText';
import { useComponentTKey, i18nNS } from '../../i18n';
import { useTranslation } from 'react-i18next';
import { CommonProperties, CommonStyles, Color } from '../../styles';
import { selectUserProfile } from '../../store/selectors/profile.selector';

const AboutModal = () => {
  const { tKey } = useComponentTKey('AboutModal');
  const { t } = useTranslation(i18nNS.settings);
  const [easy, setEasy] = useState(false);
  const [social, setSocial] = useState(false);
  const [cheap, setCheap] = useState(false);
  const companySupportDetails = useSelector(selectUserProfile);

  const onFeedbackPress = () => {
    Linking.openURL(`mailto:${companySupportDetails?.SupportContactEmail}?subject=Feedback`);
  };

  const onEasyPress = () => {
    setEasy(!easy);
  };
  const onSocialPress = () => {
    setSocial(!social);
  };
  const onCheapPress = () => {
    setCheap(!cheap);
  };
  return (
    <SafeAreaView style={styles.container}>
      <View style={CommonStyles.centerAlignment}>
        <Image style={styles.logo} source={require('../../assets/img/logo.png')} />
      </View>
      <BaseText style={styles.textStyle}>{t(tKey('AboutHeading'))}</BaseText>
      <ScrollView>
        <View>
          <BaseText style={styles.textTitle}> {t(tKey('AboutTitle'))} </BaseText>
          <BaseText style={styles.textTitle2}> {t(tKey('AboutTitle1'))} </BaseText>
          <BaseText style={styles.textBody}> {t(tKey('AboutBody1'))} </BaseText>
          <BaseText style={styles.textBody}> {t(tKey('AboutBody2'))} </BaseText>
          <BaseText style={styles.textBody}> {t(tKey('AboutBody3'))} </BaseText>
        </View>
        <NavigateRow activeColor text={t(tKey('EasyTitle'))} onPressCallback={onEasyPress} />
        {easy && <BaseText style={styles.textBody}> {t(tKey('EasyBody'))} </BaseText>}
        <NavigateRow activeColor text={t(tKey('SocialTitle'))} onPressCallback={onSocialPress} />
        {social && <BaseText style={styles.textBody}> {t(tKey('SocialBody'))} </BaseText>}
        <NavigateRow activeColor text={t(tKey('CheapTitle'))} onPressCallback={onCheapPress} />
        {cheap && <BaseText style={styles.textBody}> {t(tKey('CheapBody'))}</BaseText>}
        <View style={CommonStyles.flex1}>
          <View style={styles.divider} />
          <NavigateRow text={t(tKey('SendFeedback'))} onPressCallback={onFeedbackPress} />
        </View>
      </ScrollView>
      <View style={{ alignItems: 'center' }}>
        <BaseText> App Version {__VERSION__}</BaseText>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  textTitle: {
    color: Color.primary,
    fontSize: 20,
    marginLeft: '1%',
  },
  textTitle2: {
    fontSize: 16,
    marginLeft: '1%',
  },
  textBody: {
    marginHorizontal: '3%',
  },
  container: {
    flex: 1,
    backgroundColor: 'white',
    ...CommonProperties.p4,
  },
  logo: {
    alignSelf: 'center',
    resizeMode: 'cover',
    width: '80%',
    height: 60,
    maxWidth: 280,
  },
  textStyle: {
    textAlign: 'center',
    ...CommonProperties.my3,
  },
  divider: {
    borderBottomColor: 'black',
    borderBottomWidth: 1,
    marginTop: '4%',
  },
});

export default AboutModal;
